import { render } from "./autocomplete.vue?vue&type=template&id=2276137c"
import script from "./autocomplete.vue?vue&type=script&lang=js"
export * from "./autocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__